import React, { useState, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import LoadCharClassButton from '../../components/LoadCharClassButton';
import classButtonConfigs from '../../constants/classButtonConfigs';

import './styles.css';

const propTypes = {
  speedValues: PropTypes.oneOfType([PropTypes.object]),
  scrollPos: PropTypes.number,
  changeClass: PropTypes.func.isRequired,
  blockScroll: PropTypes.func.isRequired,
};

const defaultProps = {
  speedValues: {},
  scrollPos: 0,
};

const FlorestChooseClass = ({
  speedValues, scrollPos, changeClass, blockScroll,
}) => {
  const [buttons, setButtons] = useState(classButtonConfigs);
  const [isScrollBlocked, setIsScrollBlocked] = useState(false);
  const stopVal = isMobile ? 3700 : 3100;

  if (scrollPos > stopVal && !isScrollBlocked && buttons.length > 1) {
    setIsScrollBlocked(true);
  }

  useEffect(() => {
    if (isScrollBlocked) {
      blockScroll(true);
      setIsScrollBlocked(false);
    }
  }, [isScrollBlocked]);


  const changeCharClassAnim = charClass => {
    changeClass(charClass);
  };

  const removeNonClickedButtons = buttonId => {
    const newItem = buttons.filter(button => button.id === buttonId);
    newItem[0].disabled = true;

    setButtons(newItem);
    setIsScrollBlocked(false);
    blockScroll(false);
  };

  const classButtons = buttons.map(button => (
    <CSSTransition
      key={button.id}
      classNames="class-button-fade"
      timeout={{ enter: 500, exit: 300 }}
    >
      <LoadCharClassButton
        key={button.id}
        changeCharClassAnim={changeCharClassAnim}
        button={button}
        removeNonClickedButtons={removeNonClickedButtons}
      />
    </CSSTransition>
  ));

  const { speedSlow } = useSpring({
    from: { speedSlow: [scrollPos, 0, 0] },
    to: { speedSlow: [speedValues.slow, 0, 0] },
  });
  const { speedNormal } = useSpring({
    from: { speedNormal: [scrollPos, 0, 0] },
    to: { speedNormal: [speedValues.normal, 0, 0] },
  });
  const { speedFast } = useSpring({
    from: { speedFast: [scrollPos, 0, 0] },
    to: { speedFast: [speedValues.fast, 0, 0] },
  });
  const { speedFaster } = useSpring({
    from: { speedFaster: [scrollPos, 0, 0] },
    to: { speedFaster: [speedValues.faster, 0, 0] },
  });

  return (
    <div className="scenario-2">
      <animated.div
        className="layer-1 class-choose-container"
        style={{
          transform: speedSlow.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className="background" />
        <div className="sky" />
        <div className="star-13" />
        <div className="star-14" />
        <div className="star-15" />
      </animated.div>
      <animated.div
        className="layer-2"
        style={{
          transform: speedNormal.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className="mountain-8" />
      </animated.div>
      <animated.div
        className="layer-3"
        style={{
          transform: speedFaster.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <TransitionGroup className={`${isMobile ? 'mobile' : ''} buttons-wrapper`}>{classButtons}</TransitionGroup>
      </animated.div>
      <animated.div
        className="layer-4"
        style={{
          transform: speedFast.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className={`${isMobile ? 'mobile' : ''} class-sign`} />
      </animated.div>
    </div>
  );
};

export default FlorestChooseClass;

FlorestChooseClass.propTypes = propTypes;
FlorestChooseClass.defaultProps = defaultProps;
